export default __webpack_public_path__ + "static/media/plastilit.06ea4afc.png";